import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.to-string";
import axios from 'axios';
import { MessageBox, Message, Loading } from 'element-ui';
import store from '@/store';
import { getToken } from '@/utils/auth';
import CryptoJS from 'crypto-js';
var loading = null;
function getTime() {
  return new Date().getTime();
}
function getRequestId(url) {
  return CryptoJS.MD5(url).toString();
}
function getSign(requestId, time) {
  var salt = 'aQ#td!@43[fp'; // 是写死的一个加密盐
  var iv = 'vtN5EUY2zepPGhyy'; // 是写死的加密算法里会用到的一个参数
  var pass = '42jCD2VmqsjsaFMFScLSKFxHqQw8gKc2'; // 是写死的一组密码

  var src = CryptoJS.enc.Utf8.parse(salt + requestId + time);
  var key = CryptoJS.enc.Utf8.parse(pass);
  var ivData = CryptoJS.enc.Utf8.parse(iv);
  var encryptedData = CryptoJS.AES.encrypt(src, key, {
    iv: ivData,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  var sign = CryptoJS.enc.Base64.stringify(encryptedData.ciphertext);
  return sign;
}

// create an axios instance
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000 * 300 // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  // do something before request is sent

  // console.log('getToken:', getToken())
  // 头信息
  config.headers.Authorization = store.state.token || getToken();
  if (process.env.VUE_APP_NAME === 'tools') {
    console.log('轻应用加验签');
    // 接口签名校验（防刷防攻击）
    var time = getTime();
    var requestId = getRequestId(config.url);
    config.headers['a-req-id'] = requestId;
    config.headers['a-time'] = time;
    config.headers['a-sign'] = getSign(requestId, time);
  }
  // do something before request is sent
  if (config.loading) {
    loading = Loading.service({
      target: config.target || 'body',
      lock: true,
      text: '加载中...',
      background: config.target ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.1)'
    });
  }
  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
 */

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  loading ? loading.close() : '';
  var res = response.data;
  if (res.code === undefined) {
    return res;
  }

  // if the custom code is not 20000, it is judged as an error.
  if (res.code !== 200) {
    if (process.env.VUE_APP_NAME === 'tools' && res.msg.includes('请重试')) {
      console.log('轻应用转换失败提示不做message提示');
    } else {
      Message({
        message: res.message || res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      });
    }

    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      // to re-login
      MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
        confirmButtonText: 'Re-Login',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        store.dispatch('user/resetToken').then(function () {
          location.reload();
        });
      });
    }
    return Promise.reject(new Error(res.message || res.msg || 'Error'));
  } else {
    return res;
  }
}, function (error) {
  console.log('err' + error); // for debug
  loading ? loading.close() : '';
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
  return Promise.reject(error);
});
export default service;